import React from 'react';

import Header from '../../layout/Header.jsx';
import ListQuestions from '../../lists/ListQuestions.jsx';

const PageQuestions = () => (
  <div>
    <Header>Questions</Header>
    <ListQuestions />
  </div>
);

export default PageQuestions;
